import { render } from "./AppModal.vue?vue&type=template&id=0cd96c96&scoped=true"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"

import "./AppModal.vue?vue&type=style&index=0&id=0cd96c96&scoped=true&lang=css"

import exportComponent from "/home/alex/Work/Projects/gominigames/web/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd96c96"]])

export default __exports__